import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../store/user/userSlice';
import { readAuthContextFromStorage } from '../../store/user/userService';

export const PlayerProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRoles = useSelector((state) => state.user.userRoles);
  const userType = useSelector((state) => state.user.userType);
  const viewAsPlayerId = useSelector((state) => state.user.viewAsPlayerId);
  const [isReady, setIsReady] = useState(false);

  const checkAccess = useCallback(() => {
    const token = localStorage.getItem('token');
    if (!token || token === 'undefined') {
      return navigate('/login');
    }

    let effectiveRoles = Array.isArray(userRoles) && userRoles.length > 0
      ? userRoles
      : (userType ? [userType] : []);

    if (effectiveRoles.length === 0) {
      const hydrated = readAuthContextFromStorage();
      effectiveRoles = hydrated.roles || (hydrated.user_type ? [hydrated.user_type] : []);
      if (effectiveRoles.length > 0) {
        dispatch(userActions.setAuthContext(hydrated));
      }
    }

    // Real players: straight into the PWA.
    if (effectiveRoles.includes('player')) {
      setIsReady(true);
      return;
    }

    // Platform admins (C1 "view-as"): allowed to demo/inspect the PWA without
    // holding the `player` role. They have no mapping of their own, so they
    // must first pick which player to view; until then, route them to the
    // picker. Once chosen, the id lives in Redux + localStorage and every
    // /player/* call carries it as `as_player` (see config/api.js).
    if (effectiveRoles.includes('platform_admin')) {
      const hasViewAs = viewAsPlayerId || localStorage.getItem('view_as_player_id');
      if (hasViewAs) {
        setIsReady(true);
      } else {
        navigate('/player/view-as', { replace: true });
      }
      return;
    }

    // Club admins have no player view — back to their club screens.
    if (effectiveRoles.includes('club_admin')) {
      navigate('/club-admin/dashboard', { replace: true });
      return;
    }

    // Everyone else → main app.
    navigate('/dashboard', { replace: true });
  }, [navigate, dispatch, userRoles, userType, viewAsPlayerId]);

  useEffect(() => {
    checkAccess();
  }, [checkAccess]);

  return <>{isReady ? children : null}</>;
};
